import { useEffect, useState } from 'react';
import './WorkshopModal.css';
import Typograf from "typograf";

export default function WorkshopModal({
  workshop,
  workshops,
  onClose,
  onWorkshopChange,
}) {
  const [lightboxIndex, setLightboxIndex] = useState(null);
  const [preloadedImages, setPreloadedImages] = useState({});

  const tp = new Typograf({ locale: ["pl"] });

  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  const getIndex = () => {
    if (!workshop) return -1;
    return workshops.findIndex((w) => w.id === workshop.id);
  };

  const goPrevWorkshop = () => {
    const index = getIndex();
    if (index <= 0) return;

    onWorkshopChange(workshops[index - 1]);
  };

  const goNextWorkshop = () => {
    const index = getIndex();
    if (index === -1 || index >= workshops.length - 1) return;

    onWorkshopChange(workshops[index + 1]);
  };

  useEffect(() => {
    document.body.style.overflow = 'hidden';

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        if (lightboxIndex !== null) {
          setLightboxIndex(null);
        } else {
          onClose();
        }
      }

      if (lightboxIndex !== null) {
        if (e.key === 'ArrowRight') {
          setLightboxIndex((prev) => (prev + 1) % workshop.gallery.length);
        } else if (e.key === 'ArrowLeft') {
          setLightboxIndex((prev) =>
            (prev - 1 + workshop.gallery.length) % workshop.gallery.length
          );
        }
        return;
      }

      if (e.key === 'ArrowRight') goNextWorkshop();
      if (e.key === 'ArrowLeft') goPrevWorkshop();
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = 'auto';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [lightboxIndex, workshop, workshops]);

  const preloadImage = (index) => {
    if (!preloadedImages[index]) {
      const img = new Image();
      img.src = `${process.env.PUBLIC_URL}/${workshop.gallery[index]}`;
      setPreloadedImages((prev) => ({ ...prev, [index]: true }));
    }
  };

  const openLightbox = (index) => {
    preloadImage(index);
    setLightboxIndex(index);
  };

  const closeLightbox = () => setLightboxIndex(null);

  if (!workshop || !workshop.id) return null;

  const formatHTML = (html) =>
    html.replace(/>([^<]+)</g, (match, text) =>
      `>${tp.execute(text)}<`
    );

  const renderFields = (
    prefix,
    icon,
    hrefBuilder,
    textFormatter = (v) => v,
    labelFormatter = null
  ) => {
    return Array.from({ length: 5 }, (_, i) => {
      const suffix = i === 0 ? "" : i + 1;
      const key = `${prefix}${suffix}`;
      const value = workshop[key];

      if (!value) return null;

      const href = hrefBuilder(value);

      return (
        <div key={key}>
          <img className="ikona-modal" src={icon} alt={prefix} />
          <a
            href={href}
            target={href.startsWith("http") ? "_blank" : undefined}
            rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
          >
            {labelFormatter
              ? labelFormatter(value, suffix)
              : textFormatter(value)}
          </a>
        </div>
      );
    });
  };


  const currentIndex = workshops.findIndex((w) => w.id === workshop.id);

  const hasPrev = currentIndex > 0;
  const hasNext = currentIndex < workshops.length - 1;


  return (
    <div className='modal-overlay' onClick={onClose}>
      {hasPrev && (
        <button
          className="modal-nav modal-nav-left"
          onClick={(e) => {
            e.stopPropagation();
            goPrevWorkshop();
          }}
        >
          &#10094;
        </button>
      )}


      <div className='modal-content' onClick={(e) => e.stopPropagation()}>
        <div className="modal-scroll">
          <button className='modal-close' onClick={onClose}>
            &times;
          </button>

          <div className='top-container'>
            <img
              src={`${process.env.PUBLIC_URL}/${workshop.marker}`}
              alt='znacznik'
              className='workshop-marker-inner-modal display-desktop'
            />
            <div>
              {workshop.specialization && (
                <h4 className='text-specialization-inner-modal'>
                  {workshop.specialization}
                </h4>
              )}{' '}
              {workshop.name2 && <span>/ {workshop.name2} </span>}
              <h2 className='text-name-inner-modal'>{workshop.name}</h2>
            </div>
          </div>

          <div className='data-container'>
            <div className='data-container-top'>
              <div className='data-container-left'>
                <div className='data-container-left-top'>
                  <img
                    src={`${process.env.PUBLIC_URL}/${workshop.marker}`}
                    alt='znacznik'
                    className='workshop-marker-inner-modal display-mobile'
                  />
                  <div className='modal-info-icons display-desktop'>
                    {workshop.disabled && (
                      <img
                        className='ikona-modal-2'
                        src={`${process.env.PUBLIC_URL}/img/niepelnosprawni.svg`}
                        alt='Udogodnienia'
                        title='Dostępność dla osób z niepełnosprawnością'
                      />
                    )}
                    {workshop.accommodation && (
                      <img
                        className='ikona-modal'
                        src={`${process.env.PUBLIC_URL}/img/nocleg.svg`}
                        alt='Nocleg'
                        title='Możliwość noclegu'
                      />
                    )}
                  </div>

                  <div className='modal-text'>
                    {workshop.adress && (
                      <>
                        <p>
                          {[4, 10, 19, 37, 45].includes(workshop.id)
                            ? "ADRES (GOŚCINNIE):"
                            : "ADRES:"}
                        </p>

                        <div
                          dangerouslySetInnerHTML={{
                            __html: workshop.adress,
                          }}
                        />
                      </>
                    )}
                  </div>
                </div>

                <div className='modal-info-icons display-mobile'>
                  {workshop.disabled && (
                    <img
                      className='ikona-modal-2'
                      src={`${process.env.PUBLIC_URL}/img/niepelnosprawni.svg`}
                      alt='Udogodnienia'
                      title='Dostępność dla osób z niepełnosprawnością'
                    />
                  )}
                  {workshop.accommodation && (
                    <img
                      className='ikona-modal'
                      src={`${process.env.PUBLIC_URL}/img/nocleg.svg`}
                      alt='Nocleg'
                      title='Możliwość noclegu'
                    />
                  )}
                </div>

                {workshop.hours && (
                  <div className='hours-info'>
                    <img className='ikona-modal' src={`${process.env.PUBLIC_URL}/img/zegar.svg`} />
                    <span>{workshop.hours}</span>
                  </div>
                )}
              </div>

              <div className="data-info">
                {renderFields(
                  "tel",
                  `${process.env.PUBLIC_URL}/img/ikona-tel.svg`,
                  (v) => `tel:+48${v}`,
                  (v) => v.replace(/(\d{3})(\d{3})(\d{3})/, "$1 $2 $3")
                )}

                {renderFields(
                  "mail",
                  `${process.env.PUBLIC_URL}/img/ikona-mail.svg`,
                  (v) => `mailto:${v}`
                )}

                {renderFields(
                  "fb",
                  `${process.env.PUBLIC_URL}/img/ikona-fb.svg`,
                  (v) => `https://facebook.com/${v}`,
                  (v) => v,
                  (v, suffix) => workshop[`fbName${suffix}`] || v
                )}

                {renderFields(
                  "ig",
                  `${process.env.PUBLIC_URL}/img/ikona-ig.svg`,
                  (v) => `https://instagram.com/${v}`
                )}

                {renderFields(
                  "site",
                  `${process.env.PUBLIC_URL}/img/ikona-site.svg`,
                  (v) => `https://${v}`
                )}
              </div>
            </div>
            <div className='bottom-container'>
              {workshop.info && (
                <div
                  className="workshop-info"
                  dangerouslySetInnerHTML={{ __html: formatHTML(workshop.info) }}
                />
              )}

              <img
                src={`${process.env.PUBLIC_URL}/${workshop.image}`}
                alt={workshop.name}
                className='modal-img'
              />
            </div>

            <div className='modal-gallery'>
              {workshop.gallery?.map((img, index) => (
                <div className='img-container'>

                  <img
                    key={index}
                    src={`${process.env.PUBLIC_URL}/${img}`}
                    onClick={() => openLightbox(index)}
                    className='modal-gallery-img'
                  />
                </div>
              ))}
            </div>

            {lightboxIndex !== null && (
              <div className='lightbox' onClick={closeLightbox}>

                {/* CLOSE */}
                <button
                  className="lightbox-close"
                  onClick={(e) => {
                    e.stopPropagation();
                    closeLightbox();
                  }}
                >
                  ×
                </button>

                {/* PREV */}
                {workshop.gallery.length > 1 && (
                  <button
                    className="lightbox-prev"
                    onClick={(e) => {
                      e.stopPropagation();
                      setLightboxIndex((prev) =>
                        (prev - 1 + workshop.gallery.length) % workshop.gallery.length
                      );
                    }}
                  >
                    ‹
                  </button>
                )}

                {/* IMAGE */}
                <img
                  src={`${process.env.PUBLIC_URL}/${workshop.gallery[lightboxIndex]}`}
                  className='lightbox-img'
                  onClick={(e) => e.stopPropagation()}
                />

                {/* NEXT */}
                {workshop.gallery.length > 1 && (
                  <button
                    className="lightbox-next"
                    onClick={(e) => {
                      e.stopPropagation();
                      setLightboxIndex((prev) =>
                        (prev + 1) % workshop.gallery.length
                      );
                    }}
                  >
                    ›
                  </button>
                )}

              </div>
            )}
          </div>
        </div></div>


      {isMobile && (
        <div className="modal-bottom-bar">

          {hasPrev ? (
            <button
              className="modal-nav"
              onClick={(e) => {
                e.stopPropagation();
                goPrevWorkshop();
              }}
            >
              &#10094;
            </button>
          ) : (
            <div />
          )}

          <button
            className="modal-close"
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
          >
            &times;
          </button>

          {hasNext ? (
            <button
              className="modal-nav"
              onClick={(e) => {
                e.stopPropagation();
                goNextWorkshop();
              }}
            >
              &#10095;
            </button>
          ) : (
            <div />
          )}

        </div>
      )}


      {hasNext && (
        <button
          className="modal-nav modal-nav-right"
          onClick={(e) => {
            e.stopPropagation();
            goNextWorkshop();
          }}
        >
          &#10095;
        </button>
      )}
    </div>
  );
}